interface ProgressBarProps {
  progress: number;
}

export const ProgressBar = ({ progress }: ProgressBarProps) => {
  return (
    <div className="h-4 overflow-hidden rounded-pill bg-Gray-50">
      <div className="h-full bg-B-500" style={{ width: `${progress}%` }} />
    </div>
  );
};
